import { Injectable } from '@angular/core';
import { firstValueFrom } from 'rxjs';
import { ApiService } from '../../shared/services/api/api.service';

@Injectable({ providedIn: 'root' })
export class FileCasesService {
    constructor(private readonly apiService: ApiService) { }


    create(dto: any): Promise<any> {
        return firstValueFrom(
            this.apiService.post(`file-cases`, dto)
        );
    }

    getById(id: string): Promise<any> {
        return firstValueFrom(
            this.apiService.get(`file-cases/${id}`)
        );
    }

    update(id: string, dto: any): Promise<any> {
        return firstValueFrom(
            this.apiService.put(`file-cases/${id}`, dto)
        );
    }

  

    linkCaseToFile(fileId: number, caseId: number){
       return this.apiService.post(`file-cases/${fileId}/link-case`, { caseId });
    }

    getAll(filter:any){
        return this.apiService.post(`file-cases/get-file-cases-list`, filter);

    }
}
